import React from 'react';
import { useExperimentPageContext } from 'iron/apps/experiments/src/components/context';
import { SvgIconReact } from 'common/components/svg-icon';
import { useExposuresSeriesName } from 'iron/apps/experiments/src/components/hooks/metric-results';
import styles from './_chart-icon.module.styl';
export const VariantIcon = (_ref: {
  variant: string;
}) => {
  var _useExposuresSeriesNa;
  let {
    variant
  }: {
    variant: string;
  } = _ref;
  const {
    segmentFilterController
  } = useExperimentPageContext();
  const exposuresSeriesName = (_useExposuresSeriesNa = useExposuresSeriesName()) !== null && _useExposuresSeriesNa !== void 0 ? _useExposuresSeriesNa : "";
  const variantKey = "".concat(exposuresSeriesName, ",").concat(variant);
  const color = segmentFilterController === null || segmentFilterController === void 0 ? void 0 : segmentFilterController.getItemColor(0, variantKey);
  return <SvgIconReact className={styles.variantIcon} icon='chart-color' color={color} data-sentry-element="SvgIconReact" data-sentry-component="VariantIcon" data-sentry-source-file="_chart-icon.tsx" />;
};